import { render, staticRenderFns } from "./LandingPageLeftSide.vue?vue&type=template&id=4ba53f36&"
import script from "./LandingPageLeftSide.vue?vue&type=script&lang=ts&"
export * from "./LandingPageLeftSide.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPageLeftSide.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LandingPageLeftSide.vue"
export default component.exports